<template>
    <section class="flexContainer contentBuilderModule">
        <!-- <button @click="test">Test</button> -->
        <section id="moduleDetailsSection">
            <div id="moduleInfo" v-if="item !== null">
                <h2 id="moduleName" class="uppercase h2Title">{{ getNameEn }} / {{ getNameFr }}</h2>
                <h2 id="reference" class="uppercase h2Title">{{ diamRef1 }} / {{ clientRef1 }}</h2>
            </div>

            <div class="headerPanel"><p>Products on module</p></div>

            <div id="relImgContainer" class="fw-w">
                <div class="relatedProductImage" v-for="product in products" :key="product.id">
                    <div id="relatedImage" class="relatedImage rel fd-c jc-fs">
                        <img
                            :src="getImgPath(product.figures.big, 'big')"
                            width="200"
                            class="block imagePrincipal"
                            alt=""
                            v-if="product.figures.big !== null"
                        />
                        <h3 class="uppercase bold refRelated">
                            <span>{{ product.terms.name["en"]["value"] }} / {{ product.terms.name["fr"]["value"] }}</span>
                            <img src="../../assets/link_icon.svg" class="pointer" @click="linkProduct(product);" height="15" alt="" />
                        </h3>
                    </div>
                </div>
            </div>
            <CommentBloc v-if="_isMounted" :appId="2" :commentData="commentData"></CommentBloc>
        </section>
        <svg id="builderModule"></svg>
        <MenuShades v-if="isLoadProduct" />
    </section>
</template>

<script>
import { Component } from "./components/Component";
import Globals from "./../globals";
import { mapActions, mapGetters } from "vuex";
import { Module } from "./components/Module";
import CommentBloc from "../CommentBloc/CommentBloc";
import MenuBar from "../gui/menu/MenuBar";
import MenuItemPlano from "../gui/menu/MenuItem";
import MenuShades from "./menu/MenuShades.vue";

const d3 = require("d3");

export default {
    components: {
        CommentBloc,
        MenuBar,
        MenuItemPlano,
        MenuShades
    },
    data() {
        return {
            products: [],
            item: null,
            isLoadProduct: false,
            commentData: {
                plano: null,
                component: null,
                componentIdExternal: null
            },
            moduleEditor: null,
            makeSave: false
        };
    },
    watch: {
        onSaveModuleEdit() {
            this.setMode("plano");
            this.makeSave = true;
        },

        onDragEndShadeColor(obj) {
            console.log(obj, "======");
            let parent = obj.elt.parentNode;
            this.loadColor(obj.data, parent);
        }
    },
    computed: {
        ...mapGetters("events/planomassmarket", {
            onSaveModuleEdit: "onSaveModuleEdit",
            onDragEndShadeColor: "onDragEndShadeColor"
        }),

        getNameEn() {
            return this.getTranslate(this.item.terms.name, "en");
        },

        getNameFr() {
            return this.getTranslate(this.item.terms.name, "fr");
        },

        diamRef1() {
            return this.getValueObject(this.item, "infosArticle.diam_ref1.componentProperty.value", "");
        },
        clientRef1() {
            return this.getValueObject(this.item, "infosArticle.client_ref1.componentProperty.value", "");
        }
    },
    created() {},
    async mounted() {
        let module = Component.getSelectedComponents()[0];
        let moduleId = module.data.id;

        this.commentData.plano = { id: this.$route.params.id };
        this.commentData.component = { id: moduleId };
        this.commentData.componentIdExternal = module.data.UUID;

        this.getDetails({ id: moduleId }).then(res => {
            this.item = res;
        });

        this.getRelatedProductsAction({ id: moduleId }).then(products => {
            this.products = products;
            this.isLoadProduct = true;
        });
        let data = this.assign(module.getData());
        let moduleEditor = await Module.createEditor(data, document.querySelector("svg#builderModule"));
        this.moduleEditor = moduleEditor;
        this.addListeners();
    },

    beforeDestroy() {
        this.setDisplayMenuShades(false);
        this.isLoadProduct = false;
        if (this.makeSave) {
            let module = Component.getSelectedComponents()[0];
            let moduleEditor = this.moduleEditor;
            module.setConfig(moduleEditor.getConfig());
            this.makeSave = false;
        }
        this.moduleEditor = null;
    },

    methods: {
        ...mapActions("items", {
            getDetails: "getDetails"
        }),

        ...mapActions("plano/data", {
            getRelatedProductsAction: "getRelatedProducts"
        }),

        ...mapActions("plano/status", {
            setMode: "setMode",
            setDisplayMenuShades: "setDisplayMenuShades",
            setDisplayMenuTicketStrip: "setDisplayMenuTicketStrip"
        }),

        test() {
            console.log(this.moduleEditor);
        },

        getImgPath(imgPath, format) {
            return Globals.getBaseUrl() + imgPath;
        },

        linkProduct(item) {
            window.open("/" + item.type + "/" + item.id);
        },
        loadColor(colorData, parent) {
            let module = this.moduleEditor;
            d3.select(parent)
                .selectAll("path")
                .filter((d, j, cmps) => {
                    let cmp = cmps[j];
                    return cmp.id.includes("path_");
                })
                .each((d, j, cmps) => {
                    module.pathColor(colorData, d3.select(cmps[j]), true);
                });
        },

        addListeners() {
            let module = this.moduleEditor;
            let pathsG = module
                .getElementD3()
                .select("g#FILL")
                .selectAll("g")
                .filter((d, i, cmps) => {
                    let cmp = cmps[i];
                    return cmp.id.startsWith("row_");
                });
            pathsG.selectAll("path").select((d, i, cmps) => {
                let cmp = cmps[i];
                let pathD3 = d3.select(cmp);
                pathD3.on("click", (data, i, elts) => {
                    let selectedShade = d3.select("#shadesWrapper").select("p.selected");
                    let elt = elts[i];
                    let parent = elt.parentNode;
                    if (selectedShade.node() !== null) {
                        let shadeData = selectedShade.data()[0];
                        this.loadColor(shadeData.color, parent);
                    }
                });
            });
        }
    }
};
</script>

<style lang="scss">
.h2Title {
    margin: 10px 0px;
}

.headerPanel {
    background-color: #777777;
    color: #ffffff;
    text-transform: uppercase;
    font-size: 20px;
    padding: 8px 10px;
    p {
        margin: 0px;
    }
}

.return {
    padding-right: 10px;
    padding-bottom: 3px;
}

#builderModule {
    flex-grow: 1;
    height: calc(100% - 68px);
    padding: 40px 0;

    text,
    & tspan {
        width: 100% !important;
        font-family: "Oswald", sans-serif !important;
        text-transform: uppercase;
    }
}

.contentBuilderModule {
    height: 100%;
}

#moduleDetailsSection {
    width: 220px;
    margin-left: 60px;
    #relImgContainer {
        background: #fff;
        max-height: calc(100vh - 230px);
        height: 265px;
        overflow-y: auto;
        margin-bottom: 10px;

        .relatedProductImage {
            display: inline-block;
            vertical-align: top;
            width: 48%;
            margin: 0px 3px;

            .relatedImage {
                > img {
                    width: 70%;
                }
            }
            .refRelated span {
                line-height: 15px;
                font-size: 13px;
            }
        }
    }
}

.relatedImg {
    margin-top: 20px;
}

.cancelBtn {
    top: -102px;
    color: white;
    border: 1px solid white;
}

.closeConfModule {
    color: white;
    border: 1px solid white;
    right: 102px;
    top: -102px;
}

.imagePrincipal {
    width: 100%;
}

.badgeColorHighlight {
    display: inline-block;
    vertical-align: middle;
    height: 10px;
    width: 17px;
    margin: 0px 4px;
    border: 1px #444 solid;
}
</style>



// WEBPACK FOOTER //
// ModuleEditor.vue?2bc6ba2a